import { useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Store } from '@/shared/store';
import { getUserMarginAccounts } from '@/shared/store/userVaults/actions';

export const useGetVaultMarginAccounts = () => {
    const { marginAccounts, marginAccountsLoading, walletAddress } = useSelector(
        (state: Store) => ({
            marginAccounts: state.userVaults.marginAccounts,
            marginAccountsLoading: state.userVaults.marginAccountsLoading,
            walletAddress: state.wallets.active.address,
        }),
    );

    const dispatch = useDispatch();
    const hasFetchedMarginAccounts = useRef(false);

    const fetchMarginAccounts = useCallback(() => {
        if (walletAddress) {
            dispatch(
                getUserMarginAccounts({
                    address: walletAddress as string,
                    withoutCache: true,
                }),
            );
        } else {
            console.error('Wallet address is not defined');
        }
    }, [walletAddress]);

    useEffect(() => {
        if (!walletAddress || hasFetchedMarginAccounts.current) {
            return;
        }

        if (marginAccounts.length === 0) {
            fetchMarginAccounts();
            hasFetchedMarginAccounts.current = true;
        }
    }, [walletAddress]);

    return {
        data: marginAccounts,
        loading: marginAccountsLoading,
        fetchMarginAccounts,
    };
};
